import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowUpRight, Smartphone } from "lucide-react";
import { NAV, CONTACT, SERVICES_NAV } from "@/lib/site";

const Col = ({ title, children }) => (
  <div>
    <h4 className="font-display italic font-extrabold uppercase text-xl tracking-wide text-white mb-5">{title}</h4>
    {children}
  </div>
);

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-[var(--ink)] text-slate-300 overflow-hidden grain">
      <div aria-hidden className="absolute -right-10 -bottom-16 font-display italic font-black text-[22vw] leading-none text-white/[0.03] select-none">S4S</div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="inline-block bg-white px-4 py-3 chamfer-sm">
              <img src="/brand/logo.png?v=2" alt="S4s Enterprises Pvt. Ltd." className="h-14 w-auto" />
            </div>
            <p className="mt-6 text-sm leading-relaxed text-slate-400 max-w-sm">
              S4s Enterprises Pvt. Ltd. provides integrated single-window workforce solutions designed to allow corporate and residential clients to focus on core growth while operations run smoothly.
            </p>
          </div>
          <div className="lg:col-span-2">
            <Col title="Quick Links">
              <ul className="space-y-3 text-sm">
                {NAV.map((n) => (
                  <li key={n.to}><Link to={n.to} data-testid={`footer-link-${n.to === "/" ? "home" : n.to.slice(1)}`} className="hover:text-white hover:pl-1 transition-[color,padding] duration-300">{n.label}</Link></li>
                ))}
              </ul>
            </Col>
          </div>
          <div className="lg:col-span-3">
            <Col title="Services">
              <ul className="space-y-3 text-sm">
                {SERVICES_NAV.map((s) => (
                  <li key={s.to}><Link to={s.to} className="hover:text-white hover:pl-1 transition-[color,padding] duration-300">{s.label}</Link></li>
                ))}
              </ul>
            </Col>
          </div>
          <div className="lg:col-span-3">
            <Col title="Contact">
              <ul className="space-y-4 text-sm">
                <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#ff6b70] shrink-0" /><span data-testid="footer-address">{CONTACT.address}</span></li>
                <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-[#ff6b70] shrink-0" /><a data-testid="footer-phone" href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-white">{CONTACT.phone}</a></li>
                <li className="flex gap-3"><Smartphone className="w-4 h-4 mt-0.5 text-[#ff6b70] shrink-0" />
                  <span className="flex flex-col gap-1">
                    {CONTACT.mobiles.map((m, i) => <a key={m} data-testid={`footer-mobile-${i}`} href={`tel:${m.replace(/\s/g, "")}`} className="hover:text-white">{m}</a>)}
                  </span>
                </li>
                <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#ff6b70] shrink-0" /><a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a></li>
                <li className="flex gap-3"><Clock className="w-4 h-4 mt-0.5 text-[#ff6b70] shrink-0" /><span>{CONTACT.hours}</span></li>
              </ul>
            </Col>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-slate-400">
          <p data-testid="footer-copyright">© {year} S4s Enterprises Pvt. Ltd. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/contact" className="hover:text-white">Privacy Policy</Link>
            <Link to="/contact" className="hover:text-white">Terms of Service</Link>
            <button data-testid="footer-back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-1 hover:text-white">
              Back to top <ArrowUpRight className="w-3.5 h-3.5 -rotate-45" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
